
import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MaterialModule } from '../../material.module';

export interface MessageDialogData {
    message: string;
    title?: string;
    confirmMode?: boolean;
    confirmLabel?: string;
    type?: 'success' | 'error' | 'info' | 'warning';
    link?: string;
}

@Component({
    selector: 'app-message-dialog',
    templateUrl: './message-dialog.component.html',
    styleUrls: ['./message-dialog.component.css'],
    imports: [CommonModule, MaterialModule]
})
export class MessageDialogComponent {
    constructor(
        public dialogRef: MatDialogRef<MessageDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: MessageDialogData
    ) { }

    onClose(): void {
        this.dialogRef.close(false);
    }

    onConfirm(): void {
        this.dialogRef.close(true);
    }

    get messageType(): 'success' | 'error' | 'info' | 'warning' {
        return this.data.type ?? 'info';
    }

    get contentClass(): string {
        return `message-${this.messageType}`;
    }

    get titleClass(): string {
        return `message-title-${this.messageType}`;
    }

    get confirmButtonClass(): string {
        return this.messageType === 'warning' ? 'btn btn-warning no-arrow' : 'btn btn-danger no-arrow';
    }
}
